<template>
  <div ref="wrapper" class="root wrapper">
    <div class="scroller">
      <ul class="list">
        <li class="list-item" v-for="item in items" :key="item.key">
          <SliderCard :item="item"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IScroll from 'iscroll/build/iscroll-probe.js'
import SliderCard from '@/components/SliderCard.vue'

export default {
  name: 'Slider',
  props: ['items'],
  components: {
    SliderCard
  },
  data: function () {
    return {
      iscrollOptions: {
        scrollX: true,
        scrollY: false,
        tap: true,
        mouseWheel: true,
        probeType: 2,
        disablePointer: true,
        disableTouch: false
      },
      scroller: {
        isMobileScroll: false,
        scrolledAtEnd: false,
        direction: undefined
      }
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      const myScroll = new IScroll(this.$refs.wrapper, this.iscrollOptions)

      myScroll.on('scroll', () => {
        if (this.isMobileScroll) {
          return
        }

        const scrolledAtEnd = (
          myScroll.x === 0 && myScroll.directionX === -1
        ) || (
          myScroll.x === myScroll.maxScrollX &&
          myScroll.directionX === 1
        )

        if (scrolledAtEnd !== this.scroller.scrolledAtEnd) {
          const scrollChange = {
            ...this.scroller,
            scrolledAtEnd,
            direction: myScroll.directionX === 1 ? 'down' : 'up'
          }

          this.scroller = scrollChange
          this.$emit('scrollChange', scrollChange)
        }
      })

      myScroll.on('beforeScrollStart', () => {
        if (this.isMobileScroll) {
          return
        }

        const scrollChange = {
          ...this.scroller,
          isMobileScroll: true
        }

        this.scroller = scrollChange
        this.$emit('scrollChange', scrollChange)
      })
    })
  }
}
</script>

<style scoped lang="scss">
.root {
  font-size: 1rem;
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.scroller {
  position: absolute;
  height: 100%;
  will-change: transform;
}

.list {
  display: flex;
  align-items: center;
  height: inherit;
  padding: 0 10vw;
  white-space: nowrap;

  @media screen and (
    /* Calculation derived from .page-width */
    min-width: strip-unit($sz__site-max-width)*100/80 + 'px'
  ) {
    padding: 0 calc((100vw - #{$sz__site-max-width})/2);
  }
}

.list-item {
  display: inline-block;
  white-space: initial;

  &:not(:last-child) {
    margin-right: calc-interpolation(getEm($sz__site-min-width), 1em, getEm($sz__site-max-width), 2em);;
  }
}
</style>
